import { Category } from '../models/Category'
import { Item } from '../models/Item'
import { Type } from '../models/Type'
import { User } from '../models/User'
import { BOOK_BASE } from './constants'

type WidgetURLProps = {
    user: User
    category?: Category
    item?: Item
}

export const widgetURL = ({ user, category, item }: WidgetURLProps) => {
    const username = user.username || user.key
    const baseURL = `${BOOK_BASE}/book/${username}`

    if (category?.name) {
        const categoryURL = category.name.replaceAll('-', '').replaceAll(' ', '-').toLowerCase()
        return encodeURI(`${baseURL}/items/${categoryURL}`)
    }
    else if (item?.name) {
        const itemURL = item.name.replaceAll('-', '').replaceAll(' ', '-').toLowerCase()
        return encodeURI(`${baseURL}/item/${itemURL}`)
    }
    return baseURL
}

export const payURL = (user: User) => {
    return encodeURI(`${BOOK_BASE}/cash/${user.key}`)
}

export const downloadURL = () => {
    return encodeURI(`${BOOK_BASE}/download/app`)
}

export const formURL = (form: Type) => {
    return encodeURI(`${BOOK_BASE}/form/${form.key}`)
}
